import deploy from '../../../assets/images/deploy.svg'
import develop from '../../../assets/images/develop.svg'
import growth from '../../../assets/images/growth.svg'
import ideation from '../../../assets/images/ideation.svg'
import research from '../../../assets/images/research.svg'
import testing from '../../../assets/images/testing.svg'


const grid1 = [
    {
        id: 1,
        image: ideation,
        heading: "Ideation",
        description: "We brainstorm innovative solutions that can disrupt industries and create new markets, helping brands drive growth and profitability.",
    },
    {
        id: 2,
        image: research,
        heading: "Research",
        description: "We’re Obsessed with being informed,  identifying new opportunities for innovation and create solutions that meet the needs of their customers.",
    },
    {
        id:3,
        image: testing,
        heading: "Testing",
        description: "Ensuing that solutions are functional, reliable, and meet the needs of their target audience is of top priority to us as it helps identify and fix issues early.",
    },
]

const grid2 = [
    {
        id: 1,
        image: develop,
        heading: "Develop",
        description: "Being at the fore-front of creating , improving, and refining new technologies , software, and hardware.",
    },
    {
        id: 2,
        image: deploy,
        heading: "Deploy",
        description: "Using a variety of tools, we ensure that software products and services are deployed quickly, efficiently,  with minimal risk of errors or downtime.",
    },
    {
        id:3,
        image: growth,
        heading: "Growth",
        description: "Growth is a critical factor in the success start-up . Scaling, attracting top talent, and focusing on customer satisfaction is our watch-word.",
    },
]

function AboutUs() {
  return (
    <div className='bg-bg-black py-[100px]'>
      <div className='container mx-auto px-4 md:px-0'>
          <h2 className='font-semibold text-[28px] leading-[36px] text-white/70 md:text-[48px] md:leading-[56px] md:font-bold text-center'>Here’s what we’re about at <br /> <span className='font-extrabold text-white'>PROTIS</span></h2>

          <div className='mt-[48px] pb-[37px] px-[12px] block gap-[20px] md:flex border-b-[1.5px] border-[#494141]'>
            {grid1.map(item => (
                <div key={item.id} className="px-[22px] text-white block mx-[20px] my-[80px]">
                    <div className='flex justify-center'>
                        <img src={item.image} alt="Ideation" className="w-[68px] h-[68px] pointer-events-none" />
                    </div>
                    <h3 className='text-center font-semibold text-[28px] leading-[36px] mt-[14px]'>{item.heading}</h3>
                    <p className='text-[18px] leading-[28px] text-center mt-[14px]'>{item.description}</p>
                </div>
            ))}
          </div>

          <div className='mt-[48px] px-[12px] block gap-[20px] md:flex'>
            {grid2.map(item => (
                <div key={item.id} className="px-[22px] text-white block mx-[20px] my-[80px]">
                    <div className='flex justify-center'>
                        <img src={item.image} alt="Ideation" className="w-[68px] h-[68px] pointer-events-none" />
                    </div>
                    <h3 className='text-center font-semibold text-[28px] leading-[36px] mt-[14px]'>{item.heading}</h3>
                    <p className='text-[18px] leading-[28px] text-center mt-[14px]'>{item.description}</p>
                </div>
            ))}
          </div>
          <div></div>
      </div>
    </div>
  );
}

export default AboutUs;
